module.exports = __webpack_public_path__ + "img/hp4.53f51fbb.png";